/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 *
 *
 * @export
 * @interface SurveyTableDto
 */
export interface SurveyTableDto {
  /**
   * Unique identifier of the survey.
   *
   * @type {string}
   * @memberof SurveyTableDto
   * @example 123e4567-e89b-12d3-a456-426614174000
   */
  id: string;

  /**
   * Name of the survey.
   *
   * @type {string}
   * @memberof SurveyTableDto
   * @example Patient Satisfaction Survey
   */
  name: string;

  /**
   * Study this survey belongs to.
   *
   * @type {string}
   * @memberof SurveyTableDto
   * @example clinical-trial-2024
   */
  study?: string;

  /**
   * Priority level of the survey.
   *
   * @type {string}
   * @memberof SurveyTableDto
   * @example mandatory
   */
  priority: SurveyTableDtoPriorityEnum;

  /**
   * Whether this survey is active or not (has the survey started?).
   *
   * @type {boolean}
   * @memberof SurveyTableDto
   * @example true
   */
  is_active: boolean;

  /**
   * Type of the anonymization.
   *
   * @type {string}
   * @memberof SurveyTableDto
   * @example none
   */
  anonymization_type: SurveyTableDtoAnonymizationTypeEnum;

  /**
   * Defines who in the organization should receive the survey.
   *
   * @type {string}
   * @memberof SurveyTableDto
   * @example all_users
   */
  send_strategy: SurveyTableDtoSendStrategyEnum;

  /**
   * Date and time when the dashboard was created (ISO 8601 format)
   *
   * @type {Date}
   * @memberof SurveyTableDto
   * @example 2024-12-17T16:06:05.514Z
   */
  created_at: Date;

  /**
   * Creator of the dashboard
   *
   * @type {string}
   * @memberof SurveyTableDto
   * @example Juan
   */
  created_by: string;

  /**
   * List of organization IDs subscribed to this survey.
   *
   * @type {Array<string>}
   * @memberof SurveyTableDto
   * @example ["org-uuid-1","org-uuid-2"]
   */
  organization_ids: Array<string>;
}

/**
 * @export
 * @enum {string}
 */
export enum SurveyTableDtoPriorityEnum {
  Mandatory = 'mandatory',
  Optional = 'optional',
}
/**
 * @export
 * @enum {string}
 */
export enum SurveyTableDtoAnonymizationTypeEnum {
  None = 'none',
  AllAnswers = 'all_answers',
  Optional = 'optional',
}
/**
 * @export
 * @enum {string}
 */
export enum SurveyTableDtoSendStrategyEnum {
  AllUsers = 'all_users',
  AdminOnly = 'admin_only',
}
